import React from 'react'


export default function Alert(props) {
  const capital = (txt)=>{
          
         var p=txt.charAt(0).toUpperCase()+txt.slice(1);
         return p;
         
  }
  return (
    <div  style={{height: '50px', color: props.Mode.color==="white"?"white":"Black"}}>

  { props.Alrt && <div className="alert alert-{props.Alrt.type} alert-dismissible fade show" role="alert">
  <strong>{capital(props.Alrt.type)}</strong> {props.Alrt.msg}
  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label='Success'></button>
</div>}
    </div>
  );
}

